var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOff2 = function SvgEyeOff2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.809 13.396a8.947 8.947 0 0 0 3.183-5.771 1 1 0 0 0-1.984-.249c-.44 3.492-3.452 6.125-7.008 6.125S5.43 10.868 4.992 7.376a1 1 0 1 0-1.984.249 8.947 8.947 0 0 0 3.183 5.771l-2.312 2.312a1.003 1.003 0 0 0 0 1.414 1.003 1.003 0 0 0 1.414 0l2.603-2.603c.954.482 2.001.8 3.104.921v3.561c0 .55.45 1 1 1s1-.45 1-1V15.44a9.062 9.062 0 0 0 3.103-.921l2.604 2.603a1.003 1.003 0 0 0 1.414 0 1.003 1.003 0 0 0 0-1.414l-2.312-2.312Z",
    fill: "#B7B7B7"
  })));
};
export default SvgEyeOff2;